module.exports = __webpack_public_path__ + "flag_uk.png?95f5a216dd59fe47ef783612f860380a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag_uk.png
// module id = 21
// module chunks = 0